import { Grid, Typography } from "@mui/material";

export default function HowToDownload() {
  return (
    <Grid item container spacing={4} p={1} m={2} bgcolor="myVerify.light">
      <Grid item xs={5}>
        <Typography fontSize={18} fontWeight={700}>
          Downloading
        </Typography>
        <Typography>
          In this tool, we have provided you with some sample forms (templates)
          and other documents you may download. You may also download and review
          documents or images you have uploaded. You may also wish to download
          images, documents, or content from other websites.
        </Typography>
        <Typography mt={2}>
          There are three locations in this tool for downloading forms or items
          you have uploaded: the individual portfolio section (e.g., Resource
          Collection I), the{" "}
          <span style={{ fontWeight: 700 }}>My Uploads </span>
          screen, and the{" "}
          <span style={{ fontWeight: 700 }}>Resource Library</span> screen
        </Typography>
        <Typography mt={2}>
          This video tells you how to download a document, an image, or content
          (from this application or another site).
        </Typography>
      </Grid>
      <Grid item xs={6} display="flex" alignSelf="start" marginLeft={4}>
        {/* <video width="100%" height="auto" controls>
          <source
            src={require("../../assets/videos/sample.mp4")}
            type="video/mp4"
          />
          Your browser does not support the video tag.
        </video> */}
      </Grid>
    </Grid>
  );
}
